import generalSettings from './reducer';

export { default as generalSettingsActions } from './actions';
export { default as generalSettingsTypes } from './types';

export default generalSettings;